import httpClient from '../utils/httpClient';

const API = '/audit';

export const getAuditLogs = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.module) params.append('module', filters.module);
  if (filters.action) params.append('action', filters.action);
  if (filters.userId) params.append('userId', filters.userId);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.search) params.append('search', filters.search);
  if (filters.limit != null) params.append('limit', String(filters.limit));
  if (filters.offset != null) params.append('offset', String(filters.offset));
  const qs = params.toString();
  return httpClient.get(qs ? `${API}?${qs}` : API);
};

export const getAuditByEntity = async (entityType, entityId) =>
  httpClient.get(`${API}/entity/${entityType}/${entityId}`);

export const getAuditByUser = async (userId) => httpClient.get(`${API}/user/${userId}`);

export const getAuditSummary = async () => httpClient.get(`${API}/summary`);
